var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sa-page-layout',{attrs:{"btnRefreshVisible":"","AdiAccessiPageList":""}},[_c('template',{slot:"table-filter"}),_c('template',{slot:"table-body"},[_c('AdiAccessiListComponent')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }